import { styled } from 'stitches.config'

export const BlogHeroRoot = styled('div', {
  position: 'relative',
  height: '268px',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  backgroundColor: '$secondary-100',
  borderBottom: '9px solid transparent',
  borderTop: 0,
  borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

  paddingBottom: '$3',

  '@bp2': {
    height: '340px',
    borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
  },
})

export const SadDog = styled('div', {
  size: '$8',
  position: 'absolute',
  left: '$3',
  bottom: '$3',

  '@bp1': {
    top: 0,
  },

  '@bp2': {
    size: '124px',
    top: 'auto',
    left: '4%',
    bottom: '112px',
  },

  '@bp3': {
    left: '10%',
  },
})

export const Wrapper = styled('div', {
  position: 'relative',
  maxWidth: '$max',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',

  '@bp2': {
    height: 'auto',
  },
})

export const Energy = styled('div', {
  size: '$9',
  position: 'absolute',
  top: 0,
  left: '$3',

  '@bp2': {
    size: '124px',
    top: '$4',
    left: '17%',
  },

  '@bp3': {
    left: '20%',
  },
})

export const Chicken = styled('div', {
  size: '$10',
  position: 'absolute',
  bottom: '$1',
  left: '$4',

  '@bp2': {
    size: '124px',
    bottom: '$6',
    left: '20%',
  },

  '@bp3': {
    left: '25%',
  },
})

export const Heart = styled('div', {
  size: '$7',
  position: 'absolute',
  bottom: 'auto',
  top: '$2',
  right: '$6',

  '@bp2': {
    size: '$12',
    top: 'auto',
    bottom: '112px',
    right: '15%',
  },

  '@bp3': {
    right: '20%',
  },
})

export const Meat = styled('div', {
  display: 'none',
  size: '116px',
  position: 'absolute',
  top: '$8',

  '@bp2': {
    display: 'block',
    right: '10%',
  },

  '@bp3': {
    right: '15%',
  },
})

export const Badge = styled('div', {
  position: 'absolute',
  bottom: '$3',
  right: '$3',
  size: '64px',

  '@bp2': {
    size: '106px',
    bottom: '$5',
    right: '$5',
  },
})

export const PointedLine = styled('div', {
  height: '$7',
  borderLeft: '4px dotted $primary-500',

  '@bp2': {
    height: '$10',
  },
})
